import { useState } from 'react';
import Modal from '../../components/Modal';
import ConfirmByNameModal from '../../components/ConfirmByNameModal';
function EditAccountModal({
  editAccount,
  editForm,
  setEditForm,
  editBusy,
  onClose,
  onSubmit,
  projectOptions = [],
  canEditName = false,
  canEditProject = false,
  onDelete,
  currentUserId
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteError, setDeleteError] = useState('');
  const [deleting, setDeleting] = useState(false);
  if (!editAccount) return null;
  const isOwner = editAccount.owner_user_id === currentUserId;
  const handleDelete = () => {
    setDeleteError('');
    setConfirmOpen(true);
  };
  const confirmDelete = async typedName => {
    setDeleting(true);
    setDeleteError('');
    const result = await onDelete(editAccount.id, typedName);
    setDeleting(false);
    if (result && result.ok === false) {
      setDeleteError(result.error || 'Не удалось удалить кабинет.');
      return;
    }
    setConfirmOpen(false);
  };
  return <Modal open onClose={onClose} title="Изменить кабинет">
            {confirmOpen && <ConfirmByNameModal title="Удалить кабинет?" expectedName={editAccount.account_name} confirmLabel="Удалить кабинет" busy={deleting} error={deleteError} onClose={() => setConfirmOpen(false)} onConfirm={confirmDelete} description={<>
                    <p>Кабинет пропадёт из сервиса, а его синхронизации и автоматизации остановятся. <strong>Все данные сохраняются 30 дней</strong> (статистика, реклама, настройки, себестоимость): за это время кабинет можно восстановить в Настройках, раздел «Недавно удалённые кабинеты».</p>
                    <p className="muted">На вашу почту придёт письмо со ссылкой на копию данных. Через 30 дней данные уходят в закрытый архив — вернуть их можно через поддержку. Пустой проект удаляется отдельно, в списке проектов: кабинеты внутри него не удаляются.</p>
                </>} />}
            <p className="muted">
                Маркетплейс:{' '}
                {editAccount.marketplace_type === 'ozon' ? 'OZON' : 'Wildberries'}
            </p>
            <form className="modal__form" onSubmit={onSubmit} autoComplete="off">
                <label>
                    Название кабинета
                    <input type="text" autoComplete="off" className="modal__input" value={editForm.account_name} disabled={!canEditName} onChange={event => setEditForm({
          ...editForm,
          account_name: event.target.value
        })} />
                </label>
                {canEditProject && <label>
                        Проект
                        <select className="modal__input" value={editForm.project_id || ''} onChange={event => setEditForm({
          ...editForm,
          project_id: event.target.value
        })}>
                            <option value="">Без проекта</option>
                            {projectOptions.map(item => <option key={item.id} value={item.id}>
                                    {item.name || item.id}
                                </option>)}
                        </select>
                    </label>}
                <label>
                    API Key
                    <input type="text" autoComplete="off" name="anylex_marketplace_api_token_edit" data-form-type="other" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" autoCorrect="off" autoCapitalize="off" spellCheck={false} className="modal__input" value={editForm.api_key} onChange={event => setEditForm({
          ...editForm,
          api_key: event.target.value
        })} />
                </label>
                {editAccount.marketplace_type === 'ozon' && <>
                        <label>
                            Client ID
                            <input type="text" autoComplete="off" name="anylex_marketplace_client_identifier_edit" data-form-type="other" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" autoCorrect="off" autoCapitalize="off" spellCheck={false} className="modal__input" value={editForm.client_id} onChange={event => setEditForm({
            ...editForm,
            client_id: event.target.value
          })} />
                        </label>
                        <label>
                            Client Secret
                            <input type="text" autoComplete="off" name="anylex_marketplace_client_secret_token_edit" data-form-type="other" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" autoCorrect="off" autoCapitalize="off" spellCheck={false} className="modal__input" value={editForm.client_secret} onChange={event => setEditForm({
            ...editForm,
            client_secret: event.target.value
          })} />
                        </label>
                        <p className="muted">Seller ID редактируется только при создании кабинета.</p>
                    </>}
                <div className="modal__actions">
                    <button type="button" className="ghost" onClick={onClose}>
                        Отмена
                    </button>
                    {isOwner && onDelete && <button type="button" className="ghost danger" onClick={handleDelete}>
                            Удалить
                        </button>}
                    <button type="submit" disabled={editBusy}>
                        Сохранить
                    </button>
                </div>
            </form>
        </Modal>;
}
export default EditAccountModal;
